import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchInstancesManagerInternalService } from '../search-instances-manager-internal/search-instances-manager-internal.service';
import { DataSearchComponent } from '../../components/data-search/data-search.component';
import { SearchResultsPaginationComponent } from '../../components/search-results-pagination/search-results-pagination.component';

@Injectable()
export class SearchInstancesManagerService {
  constructor(private searchInstancesManagerInternalService: SearchInstancesManagerInternalService) {}

  getSearchScopeKey(current: HTMLElement): string {
    return this.searchInstancesManagerInternalService.getSearchScopeKey(current);
  }

  getDataSearch(scopeKey: string): Observable<DataSearchComponent> {
    return this.searchInstancesManagerInternalService.getDataSearch(scopeKey);
  }

  getSearchResultsPaginator(scopeKey: string): Observable<SearchResultsPaginationComponent> {
    return this.searchInstancesManagerInternalService.getSearchResultsPaginator(scopeKey);
  }

  addDataSearch(scopeKey: string, instance: DataSearchComponent): void {
    return this.searchInstancesManagerInternalService.addDataSearch(scopeKey, instance);
  }

  addSearchResultsPaginator(scopeKey: string, instance: SearchResultsPaginationComponent): void {
    this.searchInstancesManagerInternalService.addSearchResultsPaginator(scopeKey, instance);
  }

  removeDataSearch(scopeKey: string): void {
    this.searchInstancesManagerInternalService.removeDataSearch(scopeKey);
  }

  removeSearchResultsPaginator(scopeKey: string): void {
    this.searchInstancesManagerInternalService.removeDataSearch(scopeKey);
  }
}
